export function ParticipantFooter({ locale = "en" }: { locale?: "en" | "es" }) {
  return <footer className="participant-footer">
    <div className="participant-footer-row">
      <span className="participant-footer-brand">GLOBAL MOBILITY</span>
      <nav aria-label={locale === "es" ? "Ayuda e información legal" : "Support and legal"}>
        <a href="mailto:support@globalmobility.law">{locale === "es" ? "Contactar con soporte" : "Contact support"}</a>
        <a href="https://globalmobility.law/privacy" target="_blank" rel="noopener noreferrer">{locale === "es" ? "Privacidad" : "Privacy"}</a>
        <a href="https://globalmobility.law/terms" target="_blank" rel="noopener noreferrer">{locale === "es" ? "Términos" : "Terms"}</a>
      </nav>
    </div>
    <p>© {new Date().getFullYear()} Global Mobility Group LLC</p>
  </footer>;
}
